import React, { FC, createContext, useContext, useState } from "react";
import { PAYMENT_PLAN_TYPE } from "repoV2/constants/listing";
import { IInstalment } from "../IPaymentPlan";
import useInstalmentsDetails from "../hooks/useInstalmentsDetails";

export interface InstalmentsDetailsContextProps {
    showInstallmentsPlan: boolean;
    instalments: Array<IInstalment>;
    selectedPaymentType: number;
    handleSelectPaymentType: (type: number) => void;
    handleApplyDiscountOnInstallments: (
        payload: {
            currency?: string;
            discountCode?: string;
            appliedCount?: number;
        },
        onSuccess?: () => void
    ) => void;
    refetchInstallments: (
        payload?: {
            currency?: string;
            discountCode?: string;
            applied_count?: number;
        },
        onSuccess?: () => void
    ) => void;
    isDiscountAppliedOnInstallments: boolean;
}

const initialContextValue: InstalmentsDetailsContextProps = {
    showInstallmentsPlan: false,
    instalments: [],
    selectedPaymentType: PAYMENT_PLAN_TYPE.ONE_TIME_PAYMENT,
    handleSelectPaymentType: () => {},
    handleApplyDiscountOnInstallments: () => {},
    refetchInstallments: () => {},
    isDiscountAppliedOnInstallments: false,
};

const InstalmentsDetailsContext =
    createContext<InstalmentsDetailsContextProps>(initialContextValue);

export const InstalmentsDetailsContextProvider: FC = ({ children }) => {
    const {
        showInstallmentsPlan,
        instalments,
        handleApplyDiscountOnInstallments,
        refetchInstallments,
        isDiscountAppliedOnInstallments,
    } = useInstalmentsDetails();
    const [selectedPaymentType, setSelectedPaymentType] = useState(
        PAYMENT_PLAN_TYPE.ONE_TIME_PAYMENT
    );

    const handleSelectPaymentType = (type: number) => {
        setSelectedPaymentType(type);
    };

    return (
        <InstalmentsDetailsContext.Provider
            value={{
                showInstallmentsPlan,
                instalments,
                selectedPaymentType,
                handleSelectPaymentType,
                handleApplyDiscountOnInstallments,
                refetchInstallments,
                isDiscountAppliedOnInstallments,
            }}
        >
            {children}
        </InstalmentsDetailsContext.Provider>
    );
};

export const useInstalmentsDetailsContext = () =>
    useContext(InstalmentsDetailsContext);
